// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1YE4B","content":"ManualTimeModal_content__3Y6Hn"};